
import { useNavigate } from 'react-router-dom';

export default function TrendingTopics() {
  const navigate = useNavigate();
  
  const topics = [
    {
      id: 'topic-1',
      title: 'New Tournament Format Announced for Season 5',
      author: 'AdminTeam',
      category: 'Tournaments',
      replies: 247,
      views: 3842,
      time: '2 hours ago',
      hot: true
    },
    {
      id: 'topic-2',
      title: 'Best Loadout for Competitive Play - Updated Guide',
      author: 'ProGamer_X',
      category: 'Game Strategy',
      replies: 189,
      views: 5621,
      time: '4 hours ago',
      hot: true
    },
    {
      id: 'topic-3',
      title: 'Looking for Serious Team - Diamond+ Players',
      author: 'TeamCaptain',
      category: 'Team Recruitment',
      replies: 56,
      views: 892,
      time: '6 hours ago',
      hot: false
    },
    {
      id: 'topic-4',
      title: 'How to Improve Your Aim - Complete Training Routine',
      author: 'CoachMike',
      category: 'Training & Coaching',
      replies: 312,
      views: 7234,
      time: '8 hours ago',
      hot: true
    },
    {
      id: 'topic-5',
      title: 'Insane 1v5 Clutch - Tournament Finals',
      author: 'ClipMaster',
      category: 'Clips & Highlights',
      replies: 94,
      views: 2156,
      time: '12 hours ago',
      hot: false
    }
  ];

  const handleTopicClick = (topicId: string) => {
    navigate(`/forums/topic/${topicId}`);
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-3xl font-bold text-white mb-2">Trending Topics</h2>
            <p className="text-gray-400">Most popular discussions right now</p>
          </div>
          <button className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
            View All
          </button>
        </div>

        <div className="space-y-4">
          {topics.map((topic) => (
            <div
              key={topic.id}
              onClick={() => handleTopicClick(topic.id)}
              className="bg-gray-950 border border-gray-800 rounded-xl p-6 hover:border-teal-500/50 transition-all cursor-pointer group"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gray-800 rounded-lg group-hover:bg-teal-500/10 transition-colors">
                  <i className="ri-chat-3-line text-gray-400 group-hover:text-teal-400 text-xl transition-colors"></i>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-start gap-3 mb-2">
                    <h3 className="text-lg font-bold text-white group-hover:text-teal-400 transition-colors flex-1">
                      {topic.title}
                    </h3>
                    {topic.hot && (
                      <span className="flex-shrink-0 bg-orange-500/20 text-orange-400 px-2.5 py-1 rounded-full text-xs font-semibold">
                        <i className="ri-fire-line mr-1"></i>
                        Hot
                      </span>
                    )}
                  </div>

                  <div className="flex flex-wrap items-center gap-4 text-sm text-gray-400 mb-3">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-user-line"></i>
                      {topic.author}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-folder-line"></i>
                      {topic.category}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-time-line"></i>
                      {topic.time}
                    </span>
                  </div>

                  <div className="flex items-center gap-6 text-sm text-gray-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-chat-3-line"></i>
                      {topic.replies} replies
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line"></i>
                      {topic.views.toLocaleString()} views
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
